var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_d_332_4056)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 16,
    r: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 19.5249C14.125 19.8706 14.4043 20.1499 14.75 20.1499H17.875V17.0249H14.125V19.5249ZM19.125 20.1499H22.25C22.5957 20.1499 22.875 19.8706 22.875 19.5249V17.0249H19.125V20.1499ZM22.875 13.8999H22.0527C22.1738 13.6636 22.25 13.4019 22.25 13.1187C22.25 12.1714 21.4785 11.3999 20.5312 11.3999C19.7188 11.3999 19.1934 11.8159 18.5195 12.7339C17.8457 11.8159 17.3203 11.3999 16.5078 11.3999C15.5605 11.3999 14.7891 12.1714 14.7891 13.1187C14.7891 13.4019 14.8633 13.6636 14.9863 13.8999H14.125C13.7793 13.8999 13.5 14.1792 13.5 14.5249V16.0874C13.5 16.2593 13.6406 16.3999 13.8125 16.3999H23.1875C23.3594 16.3999 23.5 16.2593 23.5 16.0874V14.5249C23.5 14.1792 23.2207 13.8999 22.875 13.8999ZM16.5059 13.8999C16.0742 13.8999 15.7246 13.5503 15.7246 13.1187C15.7246 12.687 16.0742 12.3374 16.5059 12.3374C16.8945 12.3374 17.1816 12.4019 18.1875 13.8999H16.5059ZM20.5312 13.8999H18.8496C19.8535 12.4058 20.1328 12.3374 20.5312 12.3374C20.9629 12.3374 21.3125 12.687 21.3125 13.1187C21.3125 13.5503 20.9629 13.8999 20.5312 13.8999Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_332_4056",
    x: 0.5,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.192157 0 0 0 0 0.309804 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_332_4056"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_332_4056",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift2);
export default __webpack_public_path__ + "static/media/gift2.67886f274c0da7d35192542f65266d2b.svg";
export { ForwardRef as ReactComponent };